/** Loading state in the shell's own geometry (dock · panel · header), so
 *  nothing jumps when the session resolves. */
import { Skeleton } from "@/components/ui/Skeleton";

export function ShellSkeleton({ items = 10 }: { items?: number }) {
  return (
    <div className="min-h-screen bg-bg">
      <div className="fixed inset-y-0 left-0 hidden lg:flex">
        <div className="flex w-[68px] flex-col items-center gap-2 bg-dock py-4">
          <img src="/brand/wachsen-symbol.png?v=2" alt="" className="mb-4 h-10 w-10 opacity-80" />
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-11 w-11 rounded-xl bg-white/[0.04]" />)}
        </div>
        <div className="w-[244px] space-y-2 border-r border-border bg-bg-subtle px-3 pt-6">
          <Skeleton className="mx-2 mb-5 h-6 w-28" />
          {Array.from({ length: Math.min(items, 8) }).map((_, i) => <Skeleton key={i} className="h-[38px] w-full" />)}
        </div>
      </div>
      <div className="lg:pl-[312px]">
        <div className="flex h-16 items-center gap-3 border-b border-border px-6">
          <Skeleton className="h-6 w-40" />
        </div>
        <div className="space-y-4 px-4 py-6 sm:px-6 xl:px-10">
          <Skeleton className="h-10 w-64" />
          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-28 w-full" />)}
          </div>
          <Skeleton className="h-72 w-full" />
        </div>
      </div>
    </div>
  );
}
